var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76465 0.501953C4.34637 0.501953 0.764648 4.08367 0.764648 8.50195V22.502C0.764648 26.9202 4.34637 30.502 8.76465 30.502H22.7646C27.1829 30.502 30.7646 26.9202 30.7646 22.502V8.50195C30.7646 4.08368 27.1829 0.501953 22.7646 0.501953H8.76465ZM22.7067 8.71419L21.7254 8.32281L16.6541 13.7409L12.8785 8.67478L10.231 8.66152L8.39775 8.65233L9.49293 10.1225L14.1797 16.4141L8.2771 22.7222L9.27366 23.0742L14.7761 17.2147L18.7611 22.5641H21.4031H23.2298L22.1382 21.0994L17.2422 14.53L22.7067 8.71419ZM11.3262 10.1317L19.4964 21.0994H20.3115L12.1406 10.1358L11.3262 10.1317Z",
    fill: "#593012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bc75158f6f7dc02184aa5bdf1cc68696.svg";
export { ForwardRef as ReactComponent };